import PermissionsGrid from "./permissionsGrid";

export default PermissionsGrid;
